import {FC} from 'react';
import ImageIconSolid from '@/components/icons/ImageIconSolid';
import {cn} from '@/lib/utils';
import {Skeleton} from '@/components/ui/skeleton';
import {Roles} from "@/@types/auth.types.ts";

type Props = {
    footerButtons?: Roles;
};

const ApartmentsCardMobileSkeleton: FC<Props> = ({footerButtons}) => {
    const ownerButtons = (
        <>
            <Skeleton className='h-11 flex-1 rounded-full'/>
            <Skeleton className='h-11 flex-1 rounded-full'/>
        </>
    );

    const adminButtons = (
        <div className='flex gap-2.5'>
            <Skeleton className='size-3 m-1 rounded-full'/>
            <Skeleton className='h-3 w-20 my-1 rounded-full'/>
        </div>
    );

    return (
        <div className='relative -mx-4 p-4 flex gap-4 bg-popover-10 cursor-pointer'>
            <Skeleton className='flex-1 flex items-center justify-center rounded-semi-xl overflow-hidden'>
                <ImageIconSolid className='size-8 fill-popover-400'/>
            </Skeleton>
            <div className='flex-1 flex flex-col gap-4 truncate'>
                <div className='flex flex-col'>
                    <Skeleton className='h-3.5 w-16 my-1 rounded-full'/>
                    <Skeleton className='h-3 w-30 my-1 rounded-full'/>
                </div>
                <div className='flex flex-col gap-3'>
                    <div className='flex gap-2.5'>
                        <Skeleton className='size-3 m-1 rounded-full'/>
                        <Skeleton className='h-3 w-22 my-1 rounded-full'/>
                    </div>
                    <div className='flex gap-2.5'>
                        <Skeleton className='size-3 m-1 rounded-full'/>
                        <Skeleton className='h-3 w-12 my-1 rounded-full'/>
                    </div>
                    <div className='flex gap-2.5'>
                        <Skeleton className='size-3 m-1 rounded-full'/>
                        <Skeleton className='h-3 w-17 my-1 rounded-full'/>
                    </div>
                    <div className='flex gap-2.5'>
                        <Skeleton className='size-3 m-1 rounded-full'/>
                        <Skeleton className='h-3 w-16 my-1 rounded-full'/>
                    </div>
                </div>
                <div className='flex flex-col gap-3'>
                    {!!footerButtons && (
                        <div
                            className={cn(
                                'flex items-center',
                                footerButtons === Roles.owner ? 'gap-4' : 'gap-2.5',
                            )}>
                            {footerButtons === Roles.owner && ownerButtons}
                            {footerButtons === Roles.admin && adminButtons}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ApartmentsCardMobileSkeleton;
